<template>
  <button
    :class="{
      'a-button': true,
      'a-button_main': main,
      'a-button_additional': additional,
      'a-button_disabled': disabled,
      ['a-button_' + icon]: icon,
      ['a-button_' + accordion]: accordion,
      ['a-button_' + variant]: !disabled && variant,
      ['a-button_' + mod]: !main && mod,
    }"
    @click="
      () => {
        if (!this.disabled) this.$emit('click');
      }
    "
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "OQButton",
  props: [
    "disabled",
    "variant",
    "main",
    "mod",
    "icon",
    "accordion",
    "additional",
  ],
};
</script>

<style scoped></style>
